import { createSlice } from '@reduxjs/toolkit'
import StatusE from '../../../types/statusE'
import { ErrorT } from '../../../types/errorT'
import { NotificationSubscriptionT } from '../../../types/notificationSubscriptionT'

export interface NotificationSliceT {
  status: StatusE
  error: ErrorT | null
  subscriptions: NotificationSubscriptionT[]
  vapidPublicKey: string | null
  pushSubscription: PushSubscription | null
  isSubscribed: boolean
  isLoadingVapidKey: boolean
  isLoadingSubscriptions: boolean
}

const initialState: NotificationSliceT = {
  status: StatusE.IDLE,
  error: null,
  subscriptions: [],
  vapidPublicKey: null,
  pushSubscription: null,
  isSubscribed: false,
  isLoadingVapidKey: false,
  isLoadingSubscriptions: false,
}

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload
      if (action.payload === StatusE.LOADING) {
        state.error = null
      }
    },
    setError: (state, action) => {
      state.error = action.payload
      state.status = StatusE.ERROR
      state.isLoadingVapidKey = false
      state.isLoadingSubscriptions = false
    },
    setSubscriptions: (state, action) => {
      state.subscriptions = action.payload
      state.status = StatusE.IDLE
      state.isSubscribed = action.payload.length > 0
      state.isLoadingSubscriptions = false
    },
    setVapidKey: (state, action) => {
      state.vapidPublicKey = action.payload
      state.status = StatusE.IDLE
      state.isLoadingVapidKey = false
    },
    setLoadingVapidKey: (state, action) => {
      state.isLoadingVapidKey = action.payload
    },
    setLoadingSubscriptions: (state, action) => {
      state.isLoadingSubscriptions = action.payload
    },
    setPushSubscription: (state, action) => {
      state.pushSubscription = action.payload
    },
    setSubscriptionCreated: (state, action) => {
      state.status = StatusE.CREATED
      if (action.payload) {
        state.subscriptions = [action.payload]
        state.isSubscribed = true
      }
    },
    setSubscriptionUpdated: (state, _action) => {
      state.status = StatusE.IDLE
    },
    clearError: (state) => {
      state.error = null
    },
    reset: () => initialState,
  },
})

export const {
  setStatus,
  setError,
  setSubscriptions,
  setVapidKey,
  setLoadingVapidKey,
  setLoadingSubscriptions,
  setPushSubscription,
  setSubscriptionCreated,
  setSubscriptionUpdated,
  clearError,
  reset,
} = notificationSlice.actions

export default notificationSlice.reducer
